import React from "react";
import "./TermsAndConditions.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <div className="terms-card">
        <h1>Terms and Conditions</h1>

        <p className="effective-date">
          <strong>Effective Date:</strong> May 2026
        </p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Welcome to <span>World Dominators Hub Media & Technology Limited</span>
            (“World Dominators Hub”, “we”, “us”, or “our”). These Terms and
            Conditions govern your use of our website
            (https://wdh.it.com), purchase of digital products, templates,
            technology solutions, training programs, and expert hiring
            services.
          </p>

          <p>
            By accessing or using our services, you agree to these Terms.
          </p>
        </section>

        <section>
          <h2>2. Services</h2>
          <p>
            We provide premium media content, high-quality design templates,
            custom websites, mobile apps, software development, training &
            mentorship programs, and access to vetted media and technology
            experts.
          </p>
        </section>

        <section>
          <h2>3. Pricing and Payment</h2>
          <p>
            All prices are listed in United States Dollars (USD $). We accept
            payments via Flutterwave and other available secure payment methods.
            Prices are subject to change without prior notice.
          </p>
        </section>

        <section>
          <h2>4. Intellectual Property</h2>
          <p>
            All content, templates, designs, software, videos, and materials on
            our platform are the intellectual property of World Dominators Hub
            or our licensors. Unauthorized reproduction, distribution, or
            commercial use is strictly prohibited.
          </p>
        </section>

        <section>
          <h2>5. User Accounts</h2>
          <p>
            You are responsible for maintaining the confidentiality of your
            account credentials and for all activities that occur under your
            account.
          </p>
        </section>

        <section>
          <h2>6. Refunds</h2>
          <p>
            Please refer to our Refund Policy. Due to the digital nature of our
            products, most sales are final.
          </p>
        </section>

        <section>
          <h2>7. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, World Dominators Hub shall
            not be liable for any indirect, incidental, special, or
            consequential damages.
          </p>
        </section>

        <section>
          <h2>8. Governing Law</h2>
          <p>
            These Terms shall be governed by the laws of the Federal Republic of
            Nigeria. Disputes shall be resolved in the courts of Lagos State.
          </p>
        </section>

        <section>
          <h2>9. Changes to Terms</h2>
          <p>
            We may update these Terms from time to time. Your continued use of
            the website constitutes acceptance of the revised Terms.
          </p>
        </section>

        <section className="contact-section">
          <h2>Contact Us</h2>

          <p>
            <strong>Email:</strong>{" "}
            <a href="mailto:ericdobulertwin26@gmail.com">
               ericdobulertwin26@gmail.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong> +1 (805) 475-3211 OR +1 (914) 691-6155
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsAndConditions;